import React from 'react';
import { Drawer, Button, Row, Col, Table } from 'antd';
import { FaArrowLeft, FaDownload } from 'react-icons/fa';
import { translations } from '../../utils/constants';

const DetailDrawer = ({ isVisible, onClose ,language}) => {

    const columns = [
        { title: translations[language]?.uniqueIdentificationTxt, dataIndex: 'id', key: 'id' },
        { title: translations[language]?.typeOfDevice, dataIndex: 'type1', key: 'type1' },
        { title: translations[language]?.typeOfDevice, dataIndex: 'type2', key: 'type2' },
        { title: translations[language]?.typeOfDevice, dataIndex: 'type3', key: 'type3' },
        { title: translations[language]?.typeOfDevice, dataIndex: 'type4', key: 'type4' },
    ];

    const data = [
        {
            id: <span><p className='detail-silver-txt' >Unique Identification Code</p><p>123232</p></span>,
            type1: <span><p className='detail-silver-txt'>Type of Device </p><p>Device A</p></span>,
            type2: <span><p className='detail-silver-txt'>Type of Device </p><p>Device B</p></span>,
            type3: <span><p className='detail-silver-txt'>Type of Device </p><p>Device C</p></span>,
            type4: <span><p className='detail-silver-txt'>Type of Device </p><p>Device D</p></span>
        },
        {
            id: <span><p className='detail-silver-txt' >{translations[language]?.uniqueIdentificationTxt}</p><p>22323</p></span>,
            type1: <span><p className='detail-silver-txt'>{translations[language]?.typeOfDevice}</p><p>Device X</p></span>,
            type2: <span><p className='detail-silver-txt'>{translations[language]?.typeOfDevice}</p><p>Device Y</p></span>,
            type3: <span><p className='detail-silver-txt'>{translations[language]?.typeOfDevice}</p><p>Device Z</p></span>,
            type4: <span><p className='detail-silver-txt'>{translations[language]?.typeOfDevice}</p><p>Device W</p></span>
        },
        {
            id: <span><p className='detail-silver-txt' >{translations[language]?.uniqueIdentificationTxt}</p><p>33333</p></span>,
            type1: <span><p className='detail-silver-txt'>{translations[language]?.typeOfDevice}</p><p>Device P</p></span>,
            type2: <span><p className='detail-silver-txt'>{translations[language]?.typeOfDevice}</p><p>Device Q</p></span>,
            type3: <span><p className='detail-silver-txt'>{translations[language]?.typeOfDevice}</p><p>Device R</p></span>,
            type4: <span><p className='detail-silver-txt'>{translations[language]?.typeOfDevice}</p><p>Device S</p></span>
        },
        {
            id: <span><p className='detail-silver-txt' >{translations[language]?.uniqueIdentificationTxt}</p><p>44444</p></span>,
            type1: <span><p className='detail-silver-txt'>{translations[language]?.typeOfDevice}</p><p>Device M</p></span>,
            type2: <span><p className='detail-silver-txt'>{translations[language]?.typeOfDevice}</p><p>Device N</p></span>,
            type3: <span><p className='detail-silver-txt'>{translations[language]?.typeOfDevice}</p><p>Device O</p></span>,
            type4: <span><p className='detail-silver-txt'>{translations[language]?.typeOfDevice}</p><p>Device T</p></span>
        }
    ];

    return (
        <Drawer
            title={translations[language]?.reportsHeading}
            visible={isVisible}
            onClose={onClose}
            width={'100%'}
            placement="right"
            closable={true}
            className="custom-drawer detail-drawer"
            closeIcon={<span className="custom-close-icon"><FaArrowLeft /></span>}
            style={{ zIndex: 1001 }}
        >
            <div className="main-detail-div">
                <div className="detail-heading-div">{translations[language]?.details}</div>
                <div className='detail-drawer-table-div'>
                    <Table
                        columns={columns}
                        dataSource={data}
                        pagination={false}
                        bordered={false}
                        rowKey="id"
                        style={{
                            borderCollapse: 'collapse',
                        }}
                        components={{
                            header: {
                                cell: (props) => <th {...props} style={{ backgroundColor: '#718096', color: 'white' }} />,
                            },
                        }}
                    />
                </div>
            </div>

            <div className="report-drawer-btn-div">
                <Row gutter={16}>
                    <Col>
                        <Button className="report-cancel-btn" onClick={onClose}>
                        {translations[language]?.cancelButton   }
                        </Button>
                    </Col>
                    <Col>
                        <Button className="report-download-btn" type="primary" icon={<FaDownload style={{ marginRight: '5px' }} />} >
                        {translations[language]?.downloadButton}
                        </Button>
                    </Col>
                </Row>
            </div>
        </Drawer>
    );
};

export default DetailDrawer